import { CONSIDERED_OFFLINE_AFTER_MINS, OFFLINE_CHECKS_INTERVAL_SECONDS, OPPONENT_CONSIDERED_OFFLINE_AFTER_SECONDS } from '../../config/config';
import { clientState, getOpponentLastPing } from './client';


export const onlineStatus = {
  localPlayer: { offlineSince: null },
  opponent: { offlineSince: null },
};


setInterval(() => {
  try {
    // RESET if not in a room
    if (!clientState.inRoom) {
      if (onlineStatus.localPlayer.offlineSince) {
        onlineStatus.localPlayer.offlineSince = null;
      }
      if (onlineStatus.opponent.offlineSince) {
        onlineStatus.opponent.offlineSince = null;
      }
      return;
    }

    // ## CHECK PLAYERS STATUS
    // -- LOCAL PLAYER
    const localPlayerOffline = !clientState.isConnected || !navigator.onLine;
    if (localPlayerOffline) {
      // mark offline (if wasnt already)
      if (!onlineStatus.localPlayer.offlineSince) {
        onlineStatus.localPlayer.offlineSince = Date.now();
      }
    } else {
      // reset
      if (onlineStatus.localPlayer.offlineSince) {
        onlineStatus.localPlayer.offlineSince = null;
      }
    }
    // -- OPPONENT
    if (localPlayerOffline) {
      // ignore opponent status if local player is offline!
      if (onlineStatus.opponent.offlineSince) {
        onlineStatus.opponent.offlineSince = null; // nuke to be sure, until i'm back online
      }
      return;
    }
    const lastPing = getOpponentLastPing();
    const opponentOffline = lastPing
      && ((Date.now() - lastPing) > (OPPONENT_CONSIDERED_OFFLINE_AFTER_SECONDS * 1000)) 
    if (opponentOffline) {
      // mark offline (if wasnt already)
      if (!onlineStatus.opponent.offlineSince) {
        onlineStatus.opponent.offlineSince = Date.now();
      }
    } else {
      // reset
      if (onlineStatus.opponent.offlineSince) {
        onlineStatus.opponent.offlineSince = null;
      }
    }
  } catch (err) {
    console.error('Broke in online status checks:', err);
  }
}, OFFLINE_CHECKS_INTERVAL_SECONDS * 1000);


// Used by Game.js
export const opponentAbandonedGame = () => {
  if (!onlineStatus.opponent.offlineSince) return false; // opponent never been offline
  const opponentDurationOffline = Date.now() - onlineStatus.opponent.offlineSince;
  if (opponentDurationOffline > (CONSIDERED_OFFLINE_AFTER_MINS * 60 * 1000)) {
    return true; // opponent has been offline for a while
  }
  return false; // opponent offline but not for long enough yet
};
// @@ @@ NOTE: currently useless because local player too goes offline after a while
// after inactivity, despite the PINGs.
